














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogConfirm extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) title!: string
    @Prop(String) text!: string
}
